import dayjs from 'dayjs'
import { makeAutoObservable } from 'mobx'
import { logger } from 'shared/lib'
import { eventLogApi } from 'entities/EventLog/api'
import type { EntitiesStore } from 'entities/EntitiesExport'

export class EventLogStore {
  constructor(private _entities: EntitiesStore) {
    makeAutoObservable(this)
  }

  setUserData = () => {
    const user = this._entities.usersStore.user
    const intercom = this._entities.configStore.intercom

    if (!user) return
    if (!this._entities.organizationStore.id) return

    eventLogApi.updateSegmentEvents({
      eventType: 'identify',
      payload: {
        userId: user.id,
        traits: {
          user_avatar: user.photo_url,
          organization_id: this._entities.organizationStore.id,
          organization_name: this._entities.organizationStore.name,
          user_email: user.email,
          user_firstName: user.first_name,
          user_lastName: user.last_name,
          user_name: user.full_name,
          user_role: user.role,
          user_createdAt: dayjs.utc(user.createdAt).format('YYYY-MM-DD'),
          identify_type: 'manual',
        },
        context: {
          Intercom: {
            user_hash: intercom,
          },
        },
      },
    })
  }

  setOrganizationData = () => {
    const user = this._entities.usersStore.user

    if (!user) return
    if (!this._entities.organizationStore.id) return
    if (!this._entities.subscriptionStore.id) return

    eventLogApi.updateSegmentEvents({
      eventType: 'group',
      payload: {
        groupId: this._entities.organizationStore.id,
        userId: user.id,
        traits: {
          organization_createdAt: dayjs.utc(this._entities.organizationStore.created_at).unix(),
          organization_name: this._entities.organizationStore.name,
          people_owner_firstName: this._entities.organizationStore.owner?.first_name,
          people_owner_id: this._entities.organizationStore.owner?.id,
          people_owner_lastName: this._entities.organizationStore.owner?.last_name,
          people_owner_name: this._entities.organizationStore.owner?.full_name,
          people_owner_phone: this._entities.organizationStore.owner?.number,
          billing_subscription_planName: this._entities.subscriptionStore.plan?.id || 'unknown',
          billing_subscription_status: this._entities.subscriptionStore.status || 'unknown',
          group_type: 'manual',
        },
      },
    })
  }

  logEvent = (event = '', payload = {}, options = {}) => {
    const user = this._entities.usersStore.user

    const properties = Object.assign(payload, {
      context: options,
    })

    eventLogApi
      .updateSegmentEvents({
        eventType: 'track',
        payload: {
          userId: user ? user.id : 'anonymous_user',
          event: event,
          properties: properties,
          context: options,
        },
      })
      .catch((err) => {
        logger.error(err)
      })
  }
}
